import { apolloClient } from '../../../App';
import {
    DeliveryFragmentFragmentDoc,
    GetDeliveriesDocument,
    GetDeliveriesQuery,
    DeliveryFragmentFragment,
} from 'data/__generated__';

export const deliveriesUpdatedHandler = (updatedDeliveries: DeliveryFragmentFragment[]) => {
    let currentDeliveries = [] as GetDeliveriesQuery['deliveries'];
    // We can read query only if it has been run
    try {
        const result = apolloClient.readQuery<GetDeliveriesQuery>({
            query: GetDeliveriesDocument,
        });
        if (!result) {
            throw Error('An error occurred when reading GetDeliveriesDocument');
        }
        currentDeliveries = result.deliveries;
    } catch {
        // do nothing
    }

    const updateDeliveryIds = updatedDeliveries.map(({ _id }) => _id);
    const nonUpdatedDeliveries = currentDeliveries.filter(({ _id }) => !updateDeliveryIds.includes(_id));
    const data = { deliveries: [...updatedDeliveries, ...nonUpdatedDeliveries] };

    apolloClient.writeQuery({
        query: GetDeliveriesDocument,
        data,
    });
};

// La souscription ne transporte qu'un `DeliveryFragment`, bien plus léger que la sélection de
// GET_DELIVERY. Réécrire le résultat complet de la query à partir de ce fragment laissait des champs
// manquants dans le cache (Apollo journalise « Missing field ... ») et pouvait réinjecter un état
// périmé : la page de détail restait alors figée sur l'ancien statut et ses boutons de transition
// demeuraient désactivés. On écrit donc uniquement les champs du fragment sur l'entité normalisée.
export function deliveryUpdatedHandler(deliveryId: string, updatedDeliveries: DeliveryFragmentFragment[]) {
    const updatedDelivery = updatedDeliveries.find(({ _id }) => _id === deliveryId);
    if (!updatedDelivery) {
        return;
    }

    const cacheId = apolloClient.cache.identify({ __typename: 'Delivery', _id: deliveryId });
    if (!cacheId) {
        return;
    }

    const cachedDelivery = apolloClient.readFragment<DeliveryFragmentFragment>({
        id: cacheId,
        fragment: DeliveryFragmentFragmentDoc,
        fragmentName: 'DeliveryFragment',
    });

    // Un évènement peut arriver après la réponse de la mutation qui l'a déclenché (et la même mise à
    // jour est parfois reçue plusieurs fois) : sans ce garde-fou, un évènement en retard réécrase la
    // livraison avec un état plus ancien.
    if (cachedDelivery && cachedDelivery.updatedAt > updatedDelivery.updatedAt) {
        return;
    }

    apolloClient.writeFragment({
        id: cacheId,
        fragment: DeliveryFragmentFragmentDoc,
        fragmentName: 'DeliveryFragment',
        data: updatedDelivery,
    });
}
